import request from '@/src/apis/axios';
import { ListResponse } from '@/src/types/common';
import { plainToInstance } from 'class-transformer';
import {
  GetCreditTemplateRequestParams,
  PostCreditTemplateBulkUpsertRequestBody,
} from '@/src/apis/rest/creditTemplate.dtos';
import { CreditTemplateDto } from '@/src/models/CreditTemplateDto';
import CreditTemplateCategoryAndActiveCountDto from '@/src/models/CreditTemplateCategoryAndActiveCountDto';

const URL = {
  creditTemplate: '/admin/credit-templates',
  creditTemplateNameAndCount: '/admin/credit-templates/category-and-count',
  creditTemplateBulkUpsert: '/admin/credit-templates/bulk',
};

// 크레딧 탬플릿 리스트 조회
export const getCreditTemplateAPI = async (
  requestParams: GetCreditTemplateRequestParams,
) => {
  const { page = 1, pageSize = 10, ...rest } = requestParams;

  const { data } = await request<ListResponse<CreditTemplateDto>>({
    method: 'get',
    url: URL.creditTemplate,
    queryParams: { ...rest, page, pageSize },
  });

  const rows = plainToInstance(CreditTemplateDto, data.rows);

  return { rows, count: data.count };
};
// 크레딧 탬플릿 명과 갯수 조회
export const getCreditTemplateNameAndCountAPI = async () => {
  const { data } = await request<
    ListResponse<CreditTemplateCategoryAndActiveCountDto>
  >({
    method: 'get',
    url: URL.creditTemplateNameAndCount,
  });

  const rows = plainToInstance(
    CreditTemplateCategoryAndActiveCountDto,
    data.rows,
  );

  return { rows, count: data.count };
};

// 크레딧 탬플릿 명과 갯수 조회
export const postCreditTemplateBulkUpsertAPI = async (
  requestBody: PostCreditTemplateBulkUpsertRequestBody,
) => {
  return await request<void>({
    method: 'post',
    url: URL.creditTemplateBulkUpsert,
    requestBody,
  });
};
